module.exports = __webpack_public_path__ + "static/media/link_2.9066501d.svg";